module.exports = __webpack_public_path__ + "static/img/ag_6(1).91f0af6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_6(1).png
// module id = 864
// module chunks = 1